/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

//import Big from 'big.js';
//Added window. to allow contst to be available in entire app
//Used in javascript number math for float point errors.
window.Big = require('big.js');


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
//
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

import VueTextareaAutosize from 'vue-textarea-autosize';

Vue.use(VueTextareaAutosize);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
//
// const app = new Vue({
//     el: '#app',
// });

let Pikaday = require ('pikaday/pikaday');
window.Pikaday = require("pikaday");

// import 'alpinejs'
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

import Fuse from 'fuse.js'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

window.Bugsnag = require('@bugsnag/js');

Bugsnag.start({
  apiKey: 'ab21ca0ec42e46f89ab6789e9a555b3b',
  plugins: [new BugsnagPluginVue()]
})
